import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AutoCompleteService {
  userList: any[] = [];
  endPoint!: string;  
  constructor(private http: HttpClient) {  
      
  }  
  search(term: string):  Observable<any[]>{  
     return this.http.get(this.endPoint + '?term=' + term)
      .pipe(
          map(
            (data:any) => {return this.userList = data}
          ),
          catchError(error =>{
          return   throwError(() => "Something went wrong");
        })
      );
           
  }
    
}
